"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Slider = ({
  name,
  value,
  required,
  setValue,
  min,
  max,
  step,
  unit,
  classes
}) => _react.default.createElement("div", null, _react.default.createElement("input", {
  className: classes.input,
  type: "range",
  name: name,
  value: value || 0,
  min: min,
  max: max,
  onChange: e => setValue(name, Math.floor(e.target.value / step) * step, required)
}), _react.default.createElement("div", {
  className: classes.value
}, value || '0', unit && " ".concat(unit)));

Slider.defaultProps = {
  max: 300,
  step: 1
};
Slider.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  required: _propTypes.default.bool,
  setValue: _propTypes.default.func.isRequired,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  unit: _propTypes.default.string
};

var _default = (0, _.withFormControl)((0, _reactJss.default)(theme => ({
  input: {
    padding: 0,
    '-webkit-appearance': 'none',
    display: 'flex',
    width: '100%',
    cursor: 'pointer',
    height: theme.sizes.inputHeight,
    marginBottom: -5,
    backgroundColor: 'transparent',
    '&:focus': {
      outline: 'none'
    },
    '&::-webkit-slider-runnable-track': {
      backgroundColor: theme.colors.inputBorder,
      boxShadow: '0 0 60px 15px white',
      height: 6
    },
    '&::-webkit-slider-thumb': {
      width: 12,
      height: 12,
      borderRadius: 6,
      marginTop: -3,
      backgroundColor: theme.colors.accent,
      border: 'none',
      '-webkit-appearance': 'none'
    }
  },
  value: {
    color: theme.colors.inputText,
    fontSize: 13,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    position: 'absolute',
    top: -3,
    right: 0
  }
}))(Slider));

exports.default = _default;